import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';

const LoginPage = () => {
    const { loginWithRedirect, isAuthenticated, isLoading, user } = useAuth0();
    const navigate = useNavigate();

    useEffect(() => {
        if (isAuthenticated) {
            // User is already authenticated, redirect to dashboard or home
            // For now, let's redirect to a simple welcome log or back to home
            console.log("User authenticated:", user);
            navigate('/');
        }
    }, [isAuthenticated, navigate, user]);

    if (isLoading) {
        return (
            <div className="login-container">
                <div className="loading-spinner">Loading...</div>
            </div>
        );
    }

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-header">
                    <img src="/logo.png" alt="KYUBURN" className="login-logo" />
                    <h1 className="login-title">Welcome Back</h1>
                    <p className="login-subtitle">Sign in to your KYUBURN account</p>
                </div>

                <div className="login-actions">
                    <button
                        className="login-button primary"
                        onClick={() => loginWithRedirect()}
                    >
                        Log In / Sign Up
                    </button>
                </div>

                <div className="login-footer">
                    <p>Protected by Enterprise Grade Security</p>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
